var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side_modal"},[_c('div',{staticClass:"close-button",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }